// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/pressure-systems.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/pressure-systems/pressure-systems.js';

mount([g0]);
